// extracted by mini-css-extract-plugin
export default {"successIcon":"sidebar-actions-module__successIcon--kLOE6","successText":"sidebar-actions-module__successText--arawe"};